import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { Col, Modal, Row } from 'antd'

import moment from 'moment'

import { closingCalculationPeriodService } from './../../redux/services'

import { UIDrawerForm, UIFormSection, UIInfoBanner } from './../../components'
import UIKpiCards from './../../components/KpiCards'

class Show extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    external: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      uuid: 0,
      item: {},
      general_key: null,
    }
  }

  onOpen = (uuid, key) => {
    this.setState({
      isLoading: true,
      uuid: uuid,
      item: {},
      general_key: key,
    })

    closingCalculationPeriodService
      .show({ uuid })
      .then((response) => {
        let item = response.data.data

        this.setState(
          {
            isLoading: false,
            item: item,
          },
        )
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
          onOk: () => {
            // Force close
            return this.onClose()
          },
        })
      })
  }

  resetFields = () => {
    this.setState({
      item: {},
    })
  }

  onClose = () => {
    // Reset fields
    this.resetFields()

    // Callback
    this.props.onClose()
  }

  names = (items, emptyLabel) => {
    if (!items?.length) return emptyLabel

    return items.map((item, index) => (
      <span key={item.id}>
        {item.nome}
        {index < items.length - 1 ? <br /> : ''}
      </span>
    ))
  }

  kpis = () => {
    const { item } = this.state
    const inicio = moment(item.data_inicio)
    const fim = moment(item.data_fim)
    const dias = fim.diff(inicio, 'days') + 1
    const empresas = item.empresas ?? []
    const funcionarios = item.funcionarios ?? []

    return [
      {
        key: 'periodo',
        tone: 'blue',
        icon: <i className="fal fa-calendar-alt" />,
        title: 'Período fechado',
        value: `${inicio.format('DD/MM/YYYY')} – ${fim.format('DD/MM/YYYY')}`,
        caption: `${dias} ${dias === 1 ? 'dia' : 'dias'}`,
      },
      {
        key: 'empresas',
        tone: 'green',
        icon: <i className="fal fa-building" />,
        title: 'Empresas impactadas',
        value: empresas.length || 'Todas',
        caption: empresas.length === 1 ? empresas[0].nome : (empresas.length ? 'Empresas selecionadas' : 'Todas as empresas'),
      },
      {
        key: 'funcionarios',
        tone: 'amber',
        icon: <i className="fal fa-users" />,
        title: 'Funcionários incluídos',
        value: funcionarios.length || 'Todos',
        caption: funcionarios.length === 1 ? funcionarios[0].nome : (funcionarios.length ? 'Funcionários selecionados' : (item.departamentos?.length ? 'Dos departamentos selecionados' : 'Todos os funcionários')),
      },
      {
        key: 'fechamento',
        tone: 'violet',
        icon: <i className="fal fa-lock" />,
        title: 'Data de fechamento',
        value: item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : '-',
        caption: item.created_at ? moment(item.created_at).calendar(null, { sameElse: '[às] HH:mm' }) : null,
      },
    ]
  }

  render() {
    const { visible } = this.props
    const { isLoading, item } = this.state

    const details = [
      { key: 'empresas', icon: 'fa-building', label: 'Empresa(s)', value: this.names(item.empresas, 'Todas'), md: 12 },
      { key: 'departamentos', icon: 'fa-sitemap', label: 'Departamento(s)', value: this.names(item.departamentos, 'Todos'), md: 12 },
      { key: 'funcionarios', icon: 'fa-user', label: 'Funcionário(s)', value: this.names(item.funcionarios, 'Todos'), md: 24 },
      { key: 'inicio', icon: 'fa-calendar-alt', label: 'Data início', value: item.data_inicio ? moment(item.data_inicio).format('DD/MM/YYYY') : '-', md: 12 },
      { key: 'fim', icon: 'fa-calendar-check', label: 'Data fim', value: item.data_fim ? moment(item.data_fim).format('DD/MM/YYYY') : '-', md: 12 },
    ]

    const timeline = [
      { key: 'criacao', icon: 'fa-plus-circle', label: 'Criação', date: item.created_at },
      { key: 'atualizacao', icon: 'fa-pen', label: 'Última atualização', date: item.updated_at },
    ]

    return (
      <UIDrawerForm
        visible={visible}
        width={1100}
        onClose={this.onClose}
        isLoading={isLoading}
        showBtnSave={false}
        icon={<i className="fal fa-calendar-check" />}
        title="Visualizar fechamento do período de cálculo"
        subtitle="Resumo do período fechado para conferência e auditoria."
      >
        <div className="closing-period-show">
          <UIKpiCards items={this.kpis()} />
          <UIFormSection
            icon={<i className="fal fa-list-alt" />}
            title="Informações do período"
          >
            <Row gutter={32}>
              {details.map((detail) => (
                <Col key={detail.key} xs={24} md={detail.md}>
                  <div className="closing-period-detail">
                    <span className="closing-period-detail-icon"><i className={`fal ${detail.icon}`} /></span>
                    <div>
                      <p className="closing-period-detail-label">{detail.label}</p>
                      <div className="closing-period-detail-value">{detail.value}</div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </UIFormSection>
          <UIFormSection
            icon={<i className="fal fa-history" />}
            title="Linha do tempo"
          >
            <ol className="closing-period-timeline">
              {timeline.map((event) => (
                <li key={event.key}>
                  <span className="closing-period-detail-icon"><i className={`fal ${event.icon}`} /></span>
                  <div>
                    <p className="closing-period-detail-label">{event.label}</p>
                    <div className="closing-period-detail-value">
                      {event.date ? moment(event.date).format('DD/MM/YYYY [às] HH:mm') : '-'}
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </UIFormSection>
          <UIInfoBanner
            icon={<i className="fal fa-info-circle" />}
            title="Importante"
            description="Os dias deste período não são recalculados enquanto ele estiver fechado. Para alterar, reabra o fechamento na listagem."
          />
        </div>
      </UIDrawerForm>
    )
  }
}

export default Show
